<template>
  <div>
    <div  class="box">
      <div class="box-body">
        <div class="row">
          <h1
            v-if="storeInfo.brand_name|| brandInfo.name"
            style="position: absolute; top: -71px; left: 75px; font-size: 18px;"
          >
            {{ storeInfo.brand_name ? storeInfo.brand_name + ' - ' + storeInfo.name_short : brandInfo.name ? brandInfo.name : ''}}
          </h1>
          <div class="col-md-12">
            <!-- 上方搜尋 toolBar -->
            <div class="row">
              <div class="flex col-sm-12 mb-3">
                <span class="text-red">＊</span>
                <span> 選擇【停賣內容(名稱)】搜尋時，結果僅顯示操作停賣當下的名稱資料，若曾變更過商品、配料名稱，建議使用【停賣內容(料號)】搜尋。</span>
                <span
                  v-if="this.$route.params.store_id &&
                    this.$route.params.store_id !== 999999"
                  class="m-l-auto"
                >
                  <button
                    class="btn btn-default btn-table-title"
                    @click="goPage"
                    v-if="getRoleType === 99 || getRoleType === 30"
                  >
                    查看批次紀錄
                  </button>
                </span>
              </div>
            </div>
            <div class="dt-bootstrap">
              <div class=" row">
                <div class="flex col-sm-6 text-light">
                  <div class="col-sm-5">
                    <div class="form-group flex row h-38">
                      <date-time-picker
                        v-if="!isLoading"
                        :date="menuTime.start"
                        :enabled="isLoading"
                        :limit="startLimit"
                        :option="dateoption"
                        @change="queryChange($event, 'start_time')"
                      />
                      <span class="flex align-center p-x-5">&nbsp; ~ &nbsp;</span>
                      <date-time-picker
                        v-if="!isLoading"
                        :date="menuTime.end"
                        :limit="endLimit"
                        :option="dateoption"
                        @change="queryChange($event, 'end_time')"
                      />
                    </div>
                  </div>
                  <div class="col-sm-3 m-l-5">
                    <div
                      v-if="storeHistory"
                      class="form-group"
                    >
                      <select
                        class="form-control h-38"
                        v-model="action_type"
                        @change="queryChange($event, 'action_type')"
                      >
                        <option value=99>== 操作功能 ==</option>
                        <option value=1>永久停賣</option>
                        <option value=2>當日停賣</option>
                        <option value=3>多店停賣</option>
                        <option value=4>多店解除停賣</option>
                      </select>
                    </div>
    
                    <div
                      v-if="brandHistory"
                      class="form-group"
                    >
                      <select
                        class="form-control h-38"
                        v-model="status"
                        @change="queryChange($event, 'status')"
                      >
                        <option value=99>== 操作功能 ==</option>
                        <option value=0>多店解除停賣</option>
                        <option value=1>多店停賣</option>
                      </select>
                    </div>
                  </div>
                </div>
    
                <div class="flex col-sm-6">
                  <div class="col-sm-10 flex row justify-content-end w-100">
                    <div class="form-group">
                      <select
                        class="form-control h-38"
                        v-model="searchSelect"
                        @change="queryChange($event, 'search_select')"
                      >
                        <option :value="1">停賣內容(名稱)</option>
                        <option :value="2">停賣內容(料號)</option>
                        <option :value="3">操作帳號</option>
                        <option
                          v-if="!this.$route.params.store_id || this.$route.params.store_id === 99999"
                          :value="4"
                        >停賣指定門市</option>
                      </select>
                    </div>
                    <!-- 停賣內容(名稱) -->
                    <div class="form-group search-bar" v-if="searchSelect === 1">
                      <div class="input-group">
                        <input :disabled = "isLoading" class="form-control h-38" type="text" v-model="product_name" @input="queryChange($event, 'order_sn')">
                        <span class="input-group-addon c-pointer" @click="search(1)"><i class="fa fa-search" /></span>
                      </div>
                    </div>
                    <!-- 停賣內容(料號) -->
                    <div class="form-group search-bar" v-if="searchSelect === 2">
                      <div class="input-group">
                        <input :disabled = "isLoading" class="form-control h-38" type="text" v-model="vendor_custom_id" @input="queryChange($event, 'vendor_custom_id')">
                        <span class="input-group-addon c-pointer" @click="search(2)"><i class="fa fa-search" /></span>
                      </div>
                    </div>
                    <!-- 操作帳號 -->
                    <div class="form-group search-bar" v-if="searchSelect === 3">
                      <div class="input-group">
                        <input :disabled = "isLoading" class="form-control h-38" type="text" v-model="account" @input="queryChange($event, 'account')">
                        <span class="input-group-addon c-pointer" @click="search(3)"><i class="fa fa-search" /></span>
                      </div>
                    </div>
                    <!-- 停賣指定門市 -->
                    <div class="form-group search-bar" v-if="searchSelect === 4">
                      <div class="input-group">
                        <input :disabled = "isLoading" class="form-control h-38" type="text" v-model="store_name" @input="queryChange($event, 'store_name')">
                        <span class="input-group-addon c-pointer" @click="search(4)"><i class="fa fa-search" /></span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- Table內容 -->
            <div class="row">
              <div class="text-center m-a-100 text-light-gray">
                <div class="col-sm-12 table-responsive p-x-0 p-b-20">
                  <table aria-describedby="example1_info" role="grid" id="example1" class="table table-bordered table-striped dataTable">
                    <thead>
                    <tr role="row">
                      <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">#</th>
                      <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">操作來源</th>
                      <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">操作歸屬</th>
                      <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">操作帳號</th>
                      <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">操作功能</th>
                      <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">停賣內容</th>
                      <th v-if="brandHistory" colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">停賣指定門市</th>
                      <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">操作時間</th>
                    </tr>
                    </thead>
                    <tbody v-if="isLoading">
                      <tr>
                        <td colspan="12" class="text-center">資料讀取中......</td>
                      </tr>
                    </tbody>
                    <tbody
                      v-else-if="!isLoading && orderList.length > 0"
                    >
                    <tr class="even" role="row" v-for="(order, index) in orderList" :class="{'bg-pre-order': order.order_method === 2}">
                      <!-- index -->
                      <td class="sorting_1">{{index + 1}}</td>
                      <!-- 操作來源 -->
                      <td>
                          {{order.src_type | disItemSrcType}}
                      </td>
    
                      <!-- 操作歸屬 -->
                      <td v-if="brandHistory">
                        {{ order.brand_name ? order.brand_name : '你訂' }}
                      </td>
                      <td v-if="storeHistory">
                        {{ order.brand_name ? order.brand_name : '你訂' }}{{ order.store_name ? order.store_name : '' }}
                      </td>
    
                      <!-- 操作帳號 -->
                      <td>
                        {{ order.account }}
                      </td>
    
                      <!-- 操作功能: 批次 -->
                      <td v-if="brandHistory && order.status !== undefined">
                        {{ order.status | disItemStatus }}
                      </td>
                      <!-- <td v-if="storeHistory && order.action_type !== undefined">
                        {{ order.action_type | disItemActionType }}
                      </td> -->
                      <!-- 操作功能: 歷程 -->
                      <td v-if="storeHistory && order.is_batch !== undefined">
                        <!-- is_batch = 1 時，依 status 顯示內容 -->
                        <span v-if="order.is_batch === 1">
                          {{ order.status | disItemStatus }}
                        </span>
                        <!-- is_batch = 0 時，依 action_type 顯示內容 -->
                        <span v-else>
                          {{ order.action_type | disItemActionType }}
                        </span>
                      </td>
    
                      <!-- 停賣內容 -->
                      <td v-if="brandHistory && order.item_list">
                        <ul
                          v-if="order.item_list.package"
                          class="list-style-none p-0"
                        >
                          <li class="text-color-blue">套餐</li>
                          <li
                            v-for="(value, key) in order.item_list.package" :key="key">
                            {{ key }} - {{ value }}
                          </li>
                        </ul>
    
                        <ul
                          v-if="order.item_list.product"
                          class="list-style-none p-0"
                        >
                          <li class="text-color-blue">商品</li>
                          <li
                            v-for="(value, key) in order.item_list.product" :key="key">
                            {{ key }} - {{ value }}
                          </li>
                        </ul>
    
                        <ul
                          v-if="order.item_list.option"
                          class="list-style-none p-0"
                        >
                          <li class="text-color-blue">配料</li>
                          <li
                            v-for="(value, key) in order.item_list.option" :key="key">
                            {{ key }} - {{ value }}
                          </li>
                        </ul>
                      </td>
    
                      <td v-if="storeHistory && order.item_list">
                        <span
                          class="spanst-style-none text-color-blue"
                          v-if="
                              order.item_list.disable &&
                              order.item_list.disable.product &&
                              Object.keys(order.item_list.disable.product).length ||
                              order.item_list.disable &&
                              order.item_list.disable.package &&
                              Object.keys(order.item_list.disable.package).length ||
                              order.item_list.disable &&
                              order.item_list.disable.option &&
                              Object.keys(order.item_list.disable.option).length ||
                              order.item_list.disable &&
                              order.item_list.disable.category &&
                              Object.keys(order.item_list.disable.category).length ||
                              order.item_list.disable &&
                              order.item_list.disable.adjust &&
                              Object.keys(order.item_list.disable.adjust).length
                            "
                          >
                          新增
                        </span>
                        <ul
                          v-if="
                            order.item_list.disable &&
                            order.item_list.disable.package &&
                            Object.keys(order.item_list.disable.package).length
                          "
                        >
                          <li>套餐</li>
                          <li
                            class="list-style-none"
                            v-for="(value, key) in order.item_list.disable.package"
                            :key="key"
                            >
                            {{ key }} - {{ value }}
                          </li>
                        </ul>
                        <ul
                          v-if="
                            order.item_list.disable &&
                            order.item_list.disable.product &&
                            Object.keys(order.item_list.disable.product).length
                          "
                        >
                          <li>商品</li>
                          <li
                            class="list-style-none"
                            v-for="(value, key) in order.item_list.disable.product"
                            :key="key"
                          >
                            {{ key }} - {{ value }}
                          </li>
                        </ul>
                        <ul
                          v-if="
                            order.item_list.disable &&
                            order.item_list.disable.option &&
                            Object.keys(order.item_list.disable.option).length
                          "
                        >
                          <li>配料</li>
                          <li
                            class="list-style-none"
                            v-for="(value, key) in order.item_list.disable.option"
                            :key="key"
                          >
                            {{ key }} - {{ value }}
                          </li>
                        </ul>
                        <ul
                          v-if="
                            order.item_list.disable &&
                            order.item_list.disable.category &&
                            Object.keys(order.item_list.disable.category).length
                          "
                        >
                          <li>商品分類</li>
                          <li
                            class="list-style-none"
                            v-for="(value, key) in order.item_list.disable.category"
                            :key="key"
                          >
                            {{ key }} - {{ value }}
                          </li>
                        </ul>
                        <ul
                          v-if="
                            order.item_list.disable &&
                            order.item_list.disable.adjust &&
                            Object.keys(order.item_list.disable.adjust).length
                          "
                        >
                          <li>配料群組</li>
                          <li
                            class="list-style-none"
                            v-for="(value, key) in order.item_list.disable.adjust"
                            :key="key"
                          >
                            {{ key }} - {{ value }}
                          </li>
                        </ul>
                        <span
                          class="spanst-style-none text-color-blue"
                          v-if="
                            order.item_list.enable &&
                            order.item_list.enable.product &&
                            Object.keys(order.item_list.enable.product).length ||
                            order.item_list.enable &&
                            order.item_list.enable.package &&
                            Object.keys(order.item_list.enable.package).length ||
                            order.item_list.enable &&
                            order.item_list.enable.option &&
                            Object.keys(order.item_list.enable.option).length ||
                            order.item_list.enable &&
                            order.item_list.enable.category &&
                            Object.keys(order.item_list.enable.category).length ||
                            order.item_list.enable &&
                            order.item_list.enable.adjust &&
                            Object.keys(order.item_list.enable.adjust).length
                          "
                        >
                          解除
                        </span>
                        <ul
                          v-if="
                            order.item_list.enable &&
                            order.item_list.enable.package &&
                            Object.keys(order.item_list.enable.package).length
                          "
                        >
                          <li>套餐</li>
                          <li
                            class="list-style-none"
                            v-for="(value, key) in order.item_list.enable.package"
                            :key="key"
                          >
                            {{ key }} - {{ value }}
                          </li>
                        </ul>
                        <ul
                          v-if="
                            order.item_list.enable &&
                            order.item_list.enable.product &&
                            Object.keys(order.item_list.enable.product).length
                          "
                        >
                          <li>商品</li>
                          <li
                            class="list-style-none"
                            v-for="(value, key) in order.item_list.enable.product"
                            :key="key"
                          >
                            {{ key }} - {{ value }}
                          </li>
                        </ul>
                        <ul
                          v-if="
                            order.item_list.enable &&
                            order.item_list.enable.option &&
                            Object.keys(order.item_list.enable.option).length
                          "
                        >
                          <li>配料</li>
                          <li
                            class="list-style-none"
                            v-for="(value, key) in order.item_list.enable.option"
                            :key="key"
                          >
                            {{ key }} - {{ value }}
                          </li>
                        </ul>
                        <ul
                          v-if="
                            order.item_list.enable &&
                            order.item_list.enable.category &&
                            Object.keys(order.item_list.enable.category).length
                          "
                        >
                          <li>商品分類</li>
                          <li
                            class="list-style-none"
                            v-for="(value, key) in order.item_list.enable.category"
                            :key="key"
                          >
                            {{ key }} - {{ value }}
                          </li>
                        </ul>
                        
                        <ul
                          v-if="
                            order.item_list.enable &&
                            order.item_list.enable.adjust &&
                            Object.keys(order.item_list.enable.adjust).length
                          "
                        >
                          <li>配料群組</li>
                          <li
                            class="list-style-none"
                            v-for="(value, key) in order.item_list.enable.adjust"
                            :key="key"
                          >
                            {{ key }} - {{ value }}
                          </li>
                        </ul>
                        
                      </td>
                      <!-- 停賣指定門市 -->
                      <td v-if="brandHistory && order.store_list">
                        <span
                            v-for="(value, key, index) in order.store_list" :key="key">
                            {{ value }}
                            <span v-if="index < Object.keys(order.store_list).length - 1">、</span>
                        </span>
                      </td>
    
                      <!-- 訂單建立時間/下訂時間 -->
                      <td>{{ getTime(order.created_time) || getTime(order.create_time) }}</td>
                    </tr>
                    </tbody>
                    <tbody v-else-if="!isLoading && orderList.length === 0">
                      <tr style="background-color: white">
                        <td rowspan="1" colspan="12" style="text-align: center; padding-bottom: 80px; padding-top:80px;">
                          <img src="/static/img/noMatchdata.svg" style="max-width: 148px;" class="center-block logo">
                          <span style="margin-bottom: 80px; color: #696969;">沒有符合的資料</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div v-if="!orderList.length && $route.name === 'onSiteOrderTableInfo'" class="text-center m-a-100 text-light-gray">
                  <span class="font-size-80"><i class="ion ion-clipboard"></i></span>
                  <p class="m-t-5">沒有符合的資料</p>
                </div>
              </div>
              <paginate
                :clickPage="paginateClickPage"
                :groupAmount="paginate.groupAmount"
                :isActive="paginateIsActive"
                :pageAmount="paginateAmount"
                :total="paginate.total"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import datetimePicker from 'vue-datepicker/vue-datepicker-es6.vue'
import moment from 'moment'
import { mapGetters } from 'vuex'

export default {
  components: {
    'date-time-picker': datetimePicker
  },
  data () {
    return {
      paginate: {
        count: 10,
        groupAmount: 10,
        page: 1,
        total: 1
      },
      isLoading: false,
      // date
      menuTime: {
        start: {
          time: moment().subtract(7, 'days').format('YYYY-MM-DD')
        },
        end: {
          time: moment().format('YYYY-MM-DD')
        }
      },
      searchSelect: 1,
      storeBtnNavs: [
        { text: '永久停賣', value: 1 },
        { text: '當日停賣', value: 2 },
        { text: '多店停賣', value: 3 },
        { text: '多店解除停賣', value: 4 }
      ],
      brandBtnNavs: [
        { text: '多店停賣', value: 3 },
        { text: '多店解除停賣', value: 4 }
      ],
      startLimit: [
        {
          type: 'fromto',
          to: moment().add(1, 'day').format('YYYY-MM-DD') // 為了開始日可選到當天
        }
      ],
      endLimit: [
        {
          type: 'fromto',
          to: moment().format('YYYY-MM-DD')
        }
      ],
      dateoption: {
        type: 'day',
        week: ['一', '二', '三', '四', '五', '六', '日'],
        month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        format: 'YYYY-MM-DD',
        placeholder: '',
        inputStyle: {
          'display': 'inline-block',
          'padding': '6px',
          'line-height': '22px',
          'font-size': '16px',
          'border': '1px solid #d2d6de',
          'border-radius': '0px 3px 3px 0px',
          'color': '#555',
          'height': '38px'
        },
        color: {
          header: '#dd4b39',
          headerText: '#fff'
        },
        buttons: {
          ok: '確定',
          cancel: '取消'
        },
        overlayOpacity: 0.5, // 0.5 as default
        dismissible: true // as true as default
      },
      roleType: '',
      orderList: [],
      action_type: 99, // 操作功能 (歷程記錄-門市: 永久停賣/當日停賣/多店停賣/多店解除停賣)
      status: 99, // 操作狀態 (批次紀錄-品牌: 多店停賣/多店解除停賣)
      product_name: '', // 停賣內容(名稱)
      vendor_custom_id: '', // 停賣內容(料號)
      account: '', // 操作帳號
      store_name: '', // 停賣指定門市
      brandInfo: {},
      storeInfo: {}
    }
  },
  async created () {
    this.getTableList()
    if (this.$route.params.store_id &&
    this.$route.params.store_id !== 999999) {
      await this.getStoreInfo(this.$route.params.store_id)
    } else {
      await this.getBrandInfo(this.$route.params.brand_id)
    }
  },
  computed: {
    ...mapGetters(['getRoleType']),
    getDataH () {
      return this.$parent.getDataH
    },
    paginateAmount () {
      return Math.ceil(this.paginate.total / this.paginate.count)
    },
    storeHistory () {
      // 是否為歷程記錄(門市)
      let storeId = Number(this.$route.params.store_id) || ''
      if (storeId && storeId !== 999999) {
        return true
      } return false
    },
    brandHistory () {
      // 是否為批次記錄(品牌)
      let brandId = Number(this.$route.params.brand_id) || ''
      let storeId = Number(this.$route.params.store_id) || ''

      if (brandId && brandId !== 999999 &&
        (!storeId || storeId === 999999)) {
        return true
      } return false
    }
  },
  methods: {
    /** 換頁 */
    paginateClickPage (index) {
      this.paginate.page = index
      this.getTableList(index)
    },
    /** 是否為當下頁碼 */
    paginateIsActive (index) {
      if (Number(this.paginate.page) === index) return true
      else return false
    },
    queryChange (event, type) { // 將搜尋條件寫入 router query，便於重整，但不更新頁面
      let query = Object.assign({}, this.$route.query)
      let value = event.target ? event.target.value : (event.value === 0 ? event.value : event.value || event)

      if (JSON.stringify(value) === '{}') return
      if (value && value !== 999) query[type] = value
      else delete query[type]
      this.$router.replace({ query })
    },
    getTableList (page) {
      if (page) {
        this.paginate.page = page
        if (page === 1) this.pageGroup = 1
      }

      let storeId = Number(this.$route.params.store_id) || ''
      let brandId = Number(this.$route.params.brand_id) || ''
      let url = ''

      const data = {
        page: this.paginate.page,
        size: this.paginate.count,
        start_date: moment(this.menuTime.start.time, 'YYYY-MM-DD').format('YYYYMMDD'),
        end_date: moment(this.menuTime.end.time, 'YYYY-MM-DD').format('YYYYMMDD'),
        status: this.status,
        action_type: this.action_type,
        product_name: this.product_name, // 停賣內容(名稱)
        vendor_custom_id: this.vendor_custom_id, // 停賣內容(料號)
        store_id: storeId,
        account: this.account, // 操作帳號
        store_name: this.store_name // 停賣門市
      }

      if (storeId && storeId !== 999999) {
        // 門市: 歷程記錄
        url = `/store/${storeId}/productDisableLog`
      } else if (brandId && brandId !== 999999) {
        // 品牌: 批次紀錄
        url = `/brand/${brandId}/productBatchDisableLog`
      }
      url = url + `?page=${data.page}&size=${data.size}&start_date=${data.start_date}&end_date=${data.end_date}`

      if (this.status && this.status !== 99 && this.status !== '99') {
        url = url + '&status=' + this.status
      } else if (this.action_type && this.action_type !== 99 && this.action_type !== '99') {
        url = url + '&action_type=' + this.action_type
      }
      if (parseInt(this.searchSelect, 10) === 1 && data.product_name) {
        // use 停賣商品(名稱)
        url = url + '&product_name=' + data.product_name
      } else if (parseInt(this.searchSelect, 10) === 2 && data.vendor_custom_id) {
        // use vendor_custom_id search
        url = url + '&vendor_custom_id=' + data.vendor_custom_id
      } else if (parseInt(this.searchSelect, 10) === 3 && data.account) {
        // use account search
        url = url + '&account=' + data.account
      } else if (parseInt(this.searchSelect, 10) === 4 && data.store_name) {
        // use store_name search
        url = url + '&store_name=' + data.store_name
      }

      this.getDataH('get', url, null, (response) => {
        if (response.data.status === 200) {
          this.isLoading = false
          this.orderList = response.data.list
          this.paginate.total = response.data.meta.total_rows
        }
      })
    },
    search (method) {
      if (method === 1 && this.product_name) {
        this.getTableList(1)
      } else if (method === 2 && this.vendor_custom_id) {
        this.getTableList(1)
      } else if (method === 3 && this.account) {
        this.getTableList(1)
      } else if (method === 4 && this.store_name) {
        this.getTableList(1)
      } else if (!this.product_name && !this.vendor_custom_id && !this.account && !this.store_name) {
        // input 清空時仍需取列表資料
        this.getTableList(1)
      } else {
        this.$notify({
          title: '請輸入搜尋條件',
          duration: 1000,
          type: 'danger',
          width: 400
        })
      }
    },
    goPage () {
      let brandId = Number(this.$route.params.brand_id) || ''
      if (brandId && brandId !== 999999) {
        // 品牌: 批次紀錄
        this.$router.push(`/disItemTable/${brandId}`)
      }
    },
    getTime (time) {
      if (!time) return ''
      return moment(time, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm')
    },
    async getBrandInfo (brandId) {
      var self = this

      var url = '/brand/' + brandId
      await this.getDataH('get', url, null, function (response) {
        if (response.status === 200) {
          self.brandInfo = response.data.brand_info
        }
      })
    },
    async getStoreInfo (storeId) {
      var self = this

      const url = '/store/' + storeId + '/info'
      await this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.storeInfo = response.data.info
        }
      })
    }
  },
  watch: {
    'menuTime.end.time' (val) {
      var lastDay = moment(val, 'YYYY-MM-DD').format('YYYY-MM-DD')
      if (this.menuTime.start.time > lastDay) this.menuTime.start.time = lastDay

      this.startLimit = [
        {
          type: 'fromto',
          to: lastDay
        }
      ]

      if (val) {
        this.getTableList()
      }
    },
    'menuTime.start.time' (val) {
      const startTime = moment(this.menuTime.start.time, 'YYYY-MM-DD')
      const endTime = moment(this.menuTime.end.time, 'YYYY-MM-DD')

      if (startTime.isAfter(endTime)) {
        // 若開始時間晚於結束時間時，則將結束時間設為開始時間
        this.menuTime.end.time = this.menuTime.start.time
      }

      this.endLimit = [
        {
          type: 'fromto',
          to: moment().format('YYYY-MM-DD')
        }
      ]

      if (val) {
        this.getTableList()
      }
    },
    'status' () {
      this.getTableList(1)
    },
    'action_type' () {
      this.getTableList(1)
    },
    searchSelect (newVal) {
      // 切換選項時清空欄位
      this.product_name = ''
      this.vendor_custom_id = ''
      this.account = ''
      this.store_name = ''
    },
    product_name (newVal) {
      if (newVal === '') this.search(1)
    },
    vendor_custom_id (newVal) {
      if (newVal === '') this.search(2)
    },
    account (newVal) {
      if (newVal === '') this.search(3)
    },
    store_name (newVal) {
      if (newVal === '') this.search(4)
    }
  }
}
</script>
<style lang="sass" scoped>
$primary-color: #3c8dbc
.list-style-none
  list-style: none
table
  tbody
    tr
      td
        vertical-align: middle
.text-color-blue
  color: $primary-color
.m-l-auto
  margin-left: auto
.p-x-5
  padding: 0 5px 0 5px
.justify-content-end
  justify-content: flex-end
</style>



// WEBPACK FOOTER //
// DisItemTableHistoryTemp.vue?00a7b977